import script from "./NavbarView.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarView.vue?vue&type=script&setup=true&lang=js"

import "./NavbarView.vue?vue&type=style&index=0&id=d8c48f00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8c48f00"]])

export default __exports__